import React, { useState } from 'react';

import SearchBar from './SearchBar';
import CustomerList from './CustomerList';
import { SHorizontalDivider, SSection, SVerticalDivider, SWrapper } from '../styles/Selector.styled';

const CustomerSelector: React.FC = () => {
  const [searchBarValue, setSearchBarValue] = useState('');

  return (
    <SWrapper valueType="customer">
      <SSection>
        <SearchBar value={searchBarValue} onChange={setSearchBarValue} />
        <SHorizontalDivider />
        <CustomerList filterValue={searchBarValue} />
      </SSection>
      <SVerticalDivider />
    </SWrapper>
  );
};

export default CustomerSelector;
